import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { DataAdminSite, AdminSite, AdminSiteState } from './types';
import { Smart, SmartState } from '@/store/smart/types';

export const actions: ActionTree<AdminSiteState, RootState> = {
  get({ commit, state }): void {
    axios({
      url: '/adminsites',
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: AdminSiteState[] = response && response.data;
        commit('ADMINSITE_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('ADMINSITE_ERROR', payload);
      },
    );
  },
  getOne({ commit }, _id: string): void {
    axios({
      url: `/adminsites/${_id}`,
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: any = response && response.data;
        commit('ADMINSITE_ONE_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('ADMINSITE_ERROR', payload);
      },
    );
  },
  add({ commit }, adminsite: DataAdminSite): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: '/adminsites',
        method: 'POST',
        data: adminsite,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('ADMINSITE_ADD_ERROR', payload);
          reject();
        },
      );
    });
  },
  put({ commit }, adminsite: DataAdminSite): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: `/adminsites/${adminsite._id}`,
        method: 'PUT',
        data: adminsite,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('ADMINSITE_ERROR', payload);
          reject();
        },
      );
    });
  },
  delete({ commit }, _id: String): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: `/adminsites/${_id}`,
        method: 'DELETE',
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('ADMINSITE_DELETE_ERROR', payload);
          reject();
        },
      );
    });
  },
  getSmart({ commit }, value: any): any {
    let _idRegion = value._idRegion;
    let _idSite = value._idSite;
    axios({
      url: `/regions/${_idRegion}/sites/${_idSite}`,
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: any = response && response.data;
        // Compute isConnected field
        payload.devices.forEach((dev: any) => {
          if (dev.connected) {
            if (dev.channels === undefined || dev.channels.length === 0) {
              dev.isConnected = false;
            } else {
              let lastData = new Date('01/01/2020');
              dev.channels.forEach((ch: any) => {
                if (
                  ch.lastValue !== undefined &&
                  ch.lastValue.v !== undefined &&
                  new Date(ch.lastValue.t) > lastData
                ) {
                  lastData = new Date(ch.lastValue.t);
                }
              });
              let inactivityTimeInHour = Math.round(
                (new Date().getTime() - lastData.getTime()) / 1000 / 60 / 60,
              );
              dev.isConnected = inactivityTimeInHour < 3;
            }
          }
        });
        commit('ADMINSITE_ONE_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('ADMINSITE_ONE_ERROR', payload);
      },
    );
  },
};
